/* eslint-disable max-len */
export default {
    one: {
        section: {
            title: 'How you can benefit from <strong>a partnership</strong> with Lemlock?'
        },
        button: 'Find out more about Lemlock',
        icons: [{
            align: 'right',
            title: 'Experts from three different sectors',
            title_2_lines: 'Experts from three<br/> different sectors',
            desc: 'Lemlock is synergy which combines expertise from the following three sectors: security testers, lawyers and software engineers.'
        }, {
            align: 'right',
            title: 'Surveillance and Verification Tests',
            title_2_lines: 'Security and<br/> Verification Tests',
            desc: 'Lemlock supervises changes made to your infrastructure, software or information systems. After the verification tests you can be sure that the patches or improvements will be legally and technically compliant with documentation/report on safety status tests.'
        }, {
            align: 'right',
            title: 'Methodology and competence',
            title_2_lines: 'Methodology<br> and competence',
            desc: 'Lemlock’s tests and audits are performed in accordance with OWASP and NIST standards, as well as with ISO 27000. Our testers hold ABW certificates confirming their reliability, and the whole process is supervised by a law firm.'
        }, {
            align: 'right',
            title: 'Active monitoring',
            title_2_lines: 'Active<br> monitoring',
            desc: 'Continuity of data security irrespective of occurring threats requires continuous and active monitoring. Lemlock is like an alarm which will inform you about every single detected threat.'
        }, {
            align: 'left',
            title: 'Start within 48 hours',
            title_2_lines: 'Start within<br/> 48 hours',
            desc: 'Starting the testing process is possible within the first 48 hours. A quick start guarantee and the progress report allow to monitor the entire process in real time.'
        }, {
            align: 'left',
            title: 'Security certificates',
            title_2_lines: 'Security<br/> certificates',
            desc: 'Lemlock standard, Lemlock platinum and GDPR compliance certificate help the holder boost their reliability and trust among clients, business partners and employees.'
        }]
    },
    two: {
        section: {
            title: 'How our work is done?'
        },
        icons: [
            'contact',
            'consultation',
            'progress',
            'report',
            'surveillance',
            'certificates'
        ],
        bonus: '<span>BONUS:</span> Free consultations with an expert regarding the implementation or modification of security measures.'
    },
    three: {
        button: 'Start securing your applications and digital assets',
        section: {
            title: 'How will you be sure<br/> that your data are <strong>safe</strong> with Lemlock?',
            desc: '<p>Modern clients are people more and more aware of their rights concerning personal data protection. Companies and institutions which collect or process data gain a significant competitive advantage by proving that they treat security measures seriously.</p><p>Using Lemlock solutions you can easily notify your clients, business partners and employees that you use the right security measures.</p>'
        },
        boxes: [{
            title: 'Lemlock STANDARD',
            textTop: 'a penetration test<br/> and a security audit',
            textBottom: 'checking the level of security and eliminating detected breaches'
        }, {
            title: 'Lemlock PLATINIUM',
            textTop: 'monitoring of networks<br/> and services',
            textBottom: 'constant monitoring and immediate correction of detected vulnerabilities'
        }, {
            title: 'GDPR compliance certificate',
            textTop: 'a GDPR compliance<br/> audit',
            textBottom: 'implementing changes in compliance with GDPR requirements'
        }]
    },
    general: {
        cybersecurity_title: 'Software & Application Cybersecurity',
        consulting_title: 'Legal and Technical Consulting',
        read_more: 'See more',
        back: 'Back',
        button1: 'Tell us what you need',
        button2: 'Arrange a free consultation'
    },
    clients: {
        title: 'We\'ve been trusted by'
    },
    list: [{
        slug: 'application-security-audits-penetration-tests',
        title: 'Application Security Audits & Penetration Tests',
        subtitle: 'Find out about flaws in your web, mobile and server-side applications.',
        icon: 'icon01',
        content: {
            title: 'Penetration Tests and Security Audits',
            subtitle: 'to detect the vulnerabilities of your applications and IT systems',
            text: [
                'Let us run controlled attempts of attacks on your applications and IT systems. Such simulations of hacker attacks are a perfect way to find out whether your data are secure.',
                'Unlike a real attack, the pentest and audit are used both to detect obvious vulnerabilities, as well as those which are hidden and barely perceptible. They do not focus on the first encountered gap, but on a thorough search.',
                'The Lemlock’s team on your behalf can supervise the introduction of necessary corrections or improvements to your IT systems and applications based on the generated report with descriptions of identified vulnerabilities: their type, complexity and seriousness.'
            ],
            icons_title: 'Audits relies on <b>OWASP</b> and <b>OWASP Mobile</b> standards and are tailored to protect your:',
            icons: [{
                icon: 'web',
                title: 'Web Applications'
            }, {
                icon: 'server',
                title: 'Server-Side/Cloud Applications'
            }, {
                icon: 'important',
                title: 'Mobile Applications'
            }]
        },
        cta: [{
            text: 'Pricing',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Security_Audits_and_Penetration_Tests.pdf`
        }, {
            text: 'Ask for details',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'application-gdpr-compliant-audits',
        title: 'Application GDPR Compliant Audits',
        subtitle: 'Check whether your web, mobile and server-side applications meets technical and legal requirements of new EU law.',
        icon: 'icon02',
        content: {
            title: 'Application GDPR Compliant Audits',
            subtitle: 'to have your application compliant with new EU privacy law',
            icons_title: 'Detailed GDPR compliance audit for your:',
            icons: [{
                icon: 'web',
                title: 'Webanwendungen'
            }, {
                icon: 'server',
                title: 'Server-/Cloud-Anwendungen'
            }, {
                icon: 'important',
                title: 'Mobilen Anwendungen'
            }],
            list_numbered_title: 'Address 3 perspectives:',
            list_numbered: [{
                title: 'Legal',
                text: 'IT lawyers identifies personal information, assess the risk of processing them basing on <b>ISO 27000</b> standard and when necessary analysing your application Terms of Service.'
            }, {
                title: 'Engineering',
                text: 'System architecture and software engineers analysis application architecture their source code to check whether GDPR provisions can be met and in case they can’t, appropriate recommendations are provided.'
            }, {
                title: 'Cybersecurity',
                text: 'Security experts verifies whether personal information and GDPR provision mechanism are secured properly.'
            }],
            list_numbered_text: 'Lemlock experts are able to supervise the implementation of recommended protection mechanisms and necessary legal adjustments, thus reducing the risk of data breach or loss.'
        },
        cta: [{
            text: 'Pricing',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Audit_of_applications_compliance_with_the_GDPR.pdf`
        }, {
            text: 'Ask for details',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'continuous-pentesting',
        title: 'Continuous Pentesting & GDPR',
        subtitle: 'Each modification of the application with constant cybersecurity control.',
        icon: 'icon03',
        content: {
            title: 'Continuous Pentesting & GDPR',
            subtitle: 'Adding new features to your system with the ongoing cybersecurity and GDPR verification process',
            text: [
                'Your  business needs to evolve and so does your IT solution. You need to keep adding new functionalities so that your product can be attractive for constant changing market. However, at the time of any modification of the system, there is a risk of introducing a new vulnerability or incompatibility with GDPR. It is obvious that before the release of the new version of the application, you can order a <span class="offer-details-blue">security or GDPR audit</span>, but it can be quite time-consuming and expensive. Instead, you can manage security and GDPR privacy of your system in an ongoing way. ',
                'Thanks to Lemlock Continuous Pentesting & GDPR, you can introduce a process which may include:',
                [
                    'ongoing security checks,',
                    'ongoing technical GDPR checks,',
                    'security consulting for your development team,',
                    'swift notifications about detected breaches and vulnerabilities,',
                    'immediate correction of security measures,',
                    'ongoing monitoring of vulnerabilities of open source libraries you are using,',
                    'integrity verification of your system production environment.'
                ],
                'The security of data and applications is a continuous process, so it is worth ensuring the safety of the Continuous Delivery process together with the Lemlock security team. This will not only help you solve security problems more quickly, but also reduce the number of new vulnerabilities, as the developer team will have a Security expert to ask for assistance. ',
                'In addition, the integrity of the production environment can be constantly monitored, which will help detect whether the application has been modified (changed bank account, content changes, invisible malware scripts injections that infect employees and client computers) and consequently preventing financial and reputation losses. '
            ]
        },
        cta: [{
            text: 'Pricing',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Application_Security_Monitoring.pdf`
        }, {
            text: 'Ask for details',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'risk-management-security-policy',
        title: 'Risk management & security policy',
        subtitle: 'Assess the importance of your IT assets and adjust security strategies.',
        icon: 'icon04',
        content: {
            title: 'Risk Analysis & Security Policies / Data Governance',
            subtitle: 'to assess the risk of digital assets in your organization and provide appropriate measures to manage it',
            text: [
                'Find out what kind of data digital assets (servers, databases, applications) are processed in your organization and learn what measures should be undertaken to properly secure them. No matter whether they relate to:',
                [
                    'personal information (GDPR),',
                    'know how, recipes and trade secrets,',
                    'payroll and wages.'
                ],
                'This process will be held in accordance with <span class="offer-details-blue">ISO 2700x, GDPR</span> and other binding legal provisions.',
                'Lemlock experts can oversee the implementation of recommended changes to the Risk Management strategy and security policies and can support building the organization\'s awareness of these issues.'
            ]
        },
        cta: [{
            text: 'Pricing',
            icon: 'get',
            page: 'estimation',
            hash: 'decrease'
        }, {
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Risk_management_and_security_policy.pdf`
        }, {
            text: 'Ask for details',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'incident-handling-and-post-breach-analysis',
        title: 'Incident handling and post-breach analysis',
        subtitle: 'Be sure that you run correct legal and technical procedures in the event of a security breach.',
        icon: 'icon05',
        content: {
            title: 'Incident handling and Post-breach analysis',
            subtitle: 'to help you in the event of a cyber attack',
            text: [
                'Incidents related to data security breaches require a fast and adequate reaction involving a number of <span class="offer-details-blue">legal and technical</span> actions like:',
                [
                    'incident confirmation and interruption,',
                    'securing the system  and specifying the scale of the attack,',
                    'collecting the evidence,',
                    'informing interested parties (police, state personal data inspector, CERT and CSIRT)'
                ],
                'In these hard times trust someone who you can rely on.'
            ]
        },
        cta: [{
            text: 'Act immediately if you are a victim of cyber attack!',
            icon: 'act',
            pdf_lp: 'https://www.lemlock.com/post-breach-steps/'
        }, {
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Incident_handling_and_post_breach_analysis.pdf`
        }]
    }, {
        slug: 'staff-training',
        title: 'Staff training',
        subtitle: 'Prepare members of your organization to work in accordance with the principles of security in both legal and technical context.',
        icon: 'icon06',
        content: {
            title: 'Staff training',
            subtitle: 'to ensure that employees carry out their tasks in accordance with safety standards and react accordingly in a critical situation',
            text: [
                'Special <span class="offer-details-blue">staff training</span> will be carried out to ensure that your organization is fully compliant with the security rules and legal regulations (including the GDPR guidelines).'
            ],
            list_numbered_title: 'Numerous Lemlock experts\' observations show that in training should participate:',
            list_numbered: [{
                icon: 'network',
                title: 'Network administrators',
                text: 'They know how to administer networks and configure them taking into account the security aspect.'
            }, {
                icon: 'database',
                title: 'Developers and database administrators',
                text: 'They work in a responsible manner and provide applications, systems or databases with a high level of protection during the creation, updating or daily management.'
            }, {
                icon: 'nonTech',
                title: 'Non-technical staff',
                text: 'They are aware of the procedures, tools and policies that reduce the risk of infiltrating the organization.'
            }],
            bottom_text: [
                'Thanks to the conducted trainings, people at the above-mentioned positions will consciously obey the rules related to security and perform tasks in a manner that would not harm the company against material/non-material losses.'
            ]
        },
        cta: [{
            text: 'Download brochure',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/en/Lemlock_Staff_training.pdf`
        }, {
            text: 'Ask for details',
            icon: 'ask',
            page: 'contact'
        }]
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/en/offer.js